const state = {
	forceProjects: {},
	forceProjectHistory: {}
}

export default state
